export default {
  colors: {
    primary: '#121133',
    secondary: '',
    accent: '#C9171E',
    accentGradient: 'linear-gradient(to right, #C9171E, #E48A5F)',
    background: '#E8ECEF'
  }
}